import { Button, Grid, TextField } from "@mui/material";
import React, { useState } from "react";

interface StaffInputProps {
  existingNames: string[];
  onAdd: (name: string) => void;
}

export const StaffInput: React.FC<StaffInputProps> = ({
  existingNames,
  onAdd,
}) => {
  const [name, setName] = useState("");
  const isDuplicate = name.trim() !== "" && existingNames.includes(name.trim());

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed && !isDuplicate) {
      onAdd(trimmed);
      setName("");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        spacing={{ xs: 2 }}
        columns={{ xs: 3 }}
        alignItems="center"
      >
        <Grid size={{ xs: 2 }}>
          <TextField
            label="Neuer Mitarbeiter"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 1 }}>
          <Button
            type="submit"
            disabled={!name.trim() || isDuplicate}
            variant="contained"
            fullWidth
          >
            Hinzufügen
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
